import React from 'react'
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';
import { Link } from 'react-router-dom';

const styles = theme => ({
    fab: {
        margin: 0,
        top: 'auto',
        left: 'auto',
        bottom: 20,
        right: 20,
        position: 'fixed',
    
      },
    toolbar: theme.mixins.toolbar,
    primary: {},
    selected: {
        
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.common.white,
        '& $primary ': {
        color: theme.palette.common.white,
        },
        
    },
    notselected: {},
});

const gtag = window.gtag;

class EventTime extends React.Component {
    state = {
        anchorEl: null,
        selectedIndex: 0,
        selectedEvtId: 0,
    };
    handleMenu = event => {
        this.setState({ anchorEl: event.currentTarget });
        if (typeof(gtag) === 'function') {
            gtag('event','SCHEDULE button clicked');
        }
    };
    
    handleClose = (index,evtId) => {
        this.setState({ anchorEl: null,selectedIndex: index, selectedEvtId: evtId });
    };

    handleFabClose = () => {
        this.setState({ anchorEl: null });
    }
    
    render() {
        const { classes, events, evtId, dtlId } = this.props;
        const { anchorEl } = this.state;
        const open = Boolean(anchorEl);
        
        let evt = events.find(x => x.id === evtId) || {};
        let dtls = evt.eventDetails || [];
        let g = dtls.find(y => y.id === dtlId) || dtls[0] || {};
        let schedules = g.schedules || [];
        
        return (
            <div>
                { schedules.length === 0 ? <Button disabled variant="outlined" color="inherit" onClick={this.handleMenu} aria-label="Filter by time">Schedule</Button> : <Button variant="outlined" color="inherit" onClick={this.handleMenu} aria-label="Filter by time">Schedule</Button>}
                

                <Menu
                  id="menu-appbar"
                  anchorEl={anchorEl}
                  anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                  }}
                  transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                  }}
                  open={open}
                  onClose={this.handleFabClose}
                >
                    { isNaN(dtlId) ? <MenuItem className={this.state.selectedEvtId !== evtId ? classes.selected : classes.notselected} component={Link} to={`/event-schedule/event/${evtId}`} onClick={() => this.handleClose(0,0)}>All</MenuItem> : <MenuItem className={this.state.selectedEvtId !== evtId ? classes.selected : classes.notselected} component={Link} to={`/event-schedule/event/${evtId}/${dtlId}`} onClick={() => this.handleClose(0,0)}>All</MenuItem>}
                    
                    {schedules.map((menuItem,menuItemKey) => {
                        if (menuItem.link) {
                            if (isNaN(dtlId)) {
                                return(<MenuItem className={this.state.selectedIndex === menuItem.id ? classes.selected : classes.notselected} key={menuItemKey} component={Link} to={`/event-schedule/event/${evtId}/at/${menuItem.id}`} onClick={() => this.handleClose(menuItem.id,evtId)}>{menuItem.formattedStart}: {menuItem.shortDescription}</MenuItem>);
                            }
                            return(<MenuItem className={this.state.selectedIndex === menuItem.id ? classes.selected : classes.notselected} key={menuItemKey} component={Link} to={`/event-schedule/event/1/${dtlId}/at/${menuItem.id}`} onClick={() => this.handleClose(menuItem.id,evtId)}>{menuItem.formattedStart}: {menuItem.shortDescription}</MenuItem>);
                        }
                        else {
                            return null;
                        }
                    })}
                </Menu>
                
            </div>
        );
    }

}

EventTime.propTypes = {
    events:PropTypes.array.isRequired,
};

export default withStyles(styles)(EventTime);